import { render, staticRenderFns } from "./HeadlinePushType.vue?vue&type=template&id=51880d28&"
import script from "./HeadlinePushType.vue?vue&type=script&lang=js&"
export * from "./HeadlinePushType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports